
import CardLayout from "../Layout/CardLayout";
import React from "react";
import InversionTable from "./InversionTable";

const InversionPropiedad = (ciemId) => {

    const contributionForm =
        <InversionTable optionName={"inversionPropiedadTable"}
                  ciemId={ciemId}
        />
    ;

    return (
        <div className="container-fluid">
            <CardLayout value={"inversionPropiedadTitulo"} tablaComponent={contributionForm} />
        </div>
    );
};
export default InversionPropiedad;